export class Cart {
	constructor() {
		this.items = [];
		this.itemsMarkup = '';
		this.cartItemsMarkup = '';
		this.cartSummaryMarkup = '';
		this.cartContainerElements = document.querySelectorAll('.cart');
		this.cartSummaryElements = document.querySelectorAll('.cart-summary');
		this.sideCartToggle = document.querySelector('.drawer-toggle');
	}

	dispatchCartUpdated() {
		const totalCount = this.items.reduce(
			(sum, item) => sum + item.quantity,
			0
		);
		const event = new CustomEvent('cart:updated', {
			detail: { totalCount, items: this.items }
		});
		document.dispatchEvent(event);
	}

	// Fetch the current cart from Shopify and update local items
	async fetchCart() {
		try {
			const cartData = await fetch('/cart.js').then((res) => res.json());
			this.items = cartData.items || [];
			const response = await fetch('/?sections=cart');
			const data = await response.json();

			this.itemsMarkup = data.cart ? data.cart : '';
			// Get specific parts of the cart markup
			const cartElement = document.createElement('div');
			cartElement.innerHTML = this.itemsMarkup;
			const cartItems = cartElement.querySelector('.cart');
			const cartSummary = cartElement.querySelector('.cart-summary');
			this.cartItemsMarkup = cartItems ? cartItems.innerHTML : '';
			this.cartSummaryMarkup = cartSummary ? cartSummary.innerHTML : '';
			this.renderCartItems();
			this.renderCartSummary();
			// Dispatch event
			this.dispatchCartUpdated();
			return this.items;
		} catch (error) {
			console.error('Error fetching cart:', error);
			throw error; // Re-throw to handle it in the calling code
		}
	}

	renderCartItems() {
		this.cartContainerElements = document.querySelectorAll('.cart');
		if (this.cartContainerElements) {
			for (const cartElement of this.cartContainerElements) {
				cartElement.innerHTML = this.cartItemsMarkup;
			}
			if (!document.querySelector('.main-cart')) {
				this.sideCartToggle.checked = true;
			}
		}
	}

	renderCartSummary() {
		if (this.cartSummaryElements) {
			for (const summaryElement of this.cartSummaryElements) {
				summaryElement.innerHTML = this.cartSummaryMarkup;
			}
		}
	}

	// Add an item to the cart
	async addItem(id, quantity = 1) {
		const response = await fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id, quantity })
		});
		const data = await response.json();
		await this.fetchCart();
		await this.renderCartItems();
		return data;
	}

	// Update the quantity of an item in the cart
	async updateItem(id, quantity) {
		const response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id, quantity })
		});
		const data = await response.json();
		await this.fetchCart();
		await this.renderCartItems();
		return data;
	}

	// Remove an item from the cart (set quantity to 0)
	async removeItem(id) {
		return this.updateItem(id, 0);
	}

	// Clear the entire cart
	async clearCart() {
		const response = await fetch('/cart/clear.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' }
		});
		const data = await response.json();
		await this.fetchCart();
		return data;
	}

	// Get the current items (fetches latest from Shopify)
	async getItems() {
		return await this.fetchCart();
	}
}
